<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow; let i = index">
					<td>{{ item.document.prod_name }}</td>
					<td>
						<fa-icon *ngIf="item.document.is_private === 1" [icon]="['fas', 'lock']" class="text-warning me-1"
							ngbTooltip="Private - Limited Access"></fa-icon>
						<fa-icon *ngIf="item.document.is_private === 0" [icon]="['fas', 'globe']" class="text-success me-1"
							ngbTooltip="Public - Generally Available"></fa-icon>
						<a [routerLink]="['/' + ac.urls.documents, item.document.id]">{{
							item.document.label }}</a>

					</td>
					<td class="text-center text-nowrap">
						<div *ngIf="item.document.added_on" [ngbTooltip]="item.document.added_on | date: ac.shortPageDateTimeFmt">
							{{ item.document.added_on | timeback }}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>